import { useEffect, type ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { captureEvent } from "../analytics";
import { useAuth } from "../auth/useAuth";
import { LoadingState } from "./LoadingState";

/**
 * RequirePaid — Task 9.9 route guard. Renders children only for paid users;
 * redirects free users to /upgrade and unauthenticated users to home (where
 * the sign-in prompt lives). Used to wrap paid-only pages (saved, compare,
 * alerts). Defense-in-depth — the backend tier-gates every endpoint too.
 */
export function RequirePaid({ children }: { children: ReactNode }) {
  const auth = useAuth();
  // A signed-in free user landing on a paid-only page is a paywall moment.
  const freeBlocked = !auth.loading && !!auth.user && auth.tier !== "paid";
  useEffect(() => {
    if (freeBlocked) captureEvent("paywall_hit", { reason: "pro_route" });
  }, [freeBlocked]);
  if (auth.loading) return <LoadingState message="Signing you in…" />;
  if (!auth.user) return <Navigate to="/" replace />;
  if (auth.tier !== "paid") return <Navigate to="/upgrade" replace />;
  return <>{children}</>;
}
